import type { MockOrder } from '../../../mocks/trackingOrders';

interface OrderDetailsProps {
  order: MockOrder;
}

const OrderDetails = ({ order }: OrderDetailsProps) => (
  <div className="bg-white border border-stone-100 rounded-2xl p-6 lg:p-8">
    <h3 className="text-xs font-body uppercase tracking-widest text-stone-400 mb-5">Resumen del pedido</h3>

    {/* Product */}
    <div className="flex items-center gap-4 pb-6 border-b border-stone-100">
      <div className="w-16 h-16 rounded-xl overflow-hidden flex-shrink-0">
        <img
          src="https://public.readdy.ai/ai/img_res/442d1c8096156743ccd85406560b1e77.jpg"
          alt="HELIX Ring"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="flex-1 min-w-0">
        <p className="font-display text-base font-semibold text-stone-900 mb-0.5">{order.product}</p>
        <p className="text-xs text-stone-500 font-body">{order.variant}</p>
      </div>
      <div className="flex-shrink-0 text-right">
        <p className="font-body font-semibold text-stone-900 text-base">{order.price}</p>
      </div>
    </div>

    {/* Customer & Shipping */}
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 mt-5">
      <div>
        <p className="text-xs text-stone-400 font-body uppercase tracking-wide mb-2">Cliente</p>
        <p className="text-sm font-body text-stone-700">{order.customerName}</p>
      </div>
      <div>
        <p className="text-xs text-stone-400 font-body uppercase tracking-wide mb-2">Dirección de envío</p>
        <p className="text-sm font-body text-stone-700 leading-relaxed">{order.shippingAddress}</p>
      </div>
    </div>

    {/* Help */}
    <div className="mt-6 pt-5 border-t border-stone-100">
      <p className="text-xs text-stone-400 font-body mb-3">¿Tienes algún problema con tu pedido?</p>
      <a
        href="mailto:hola@helixring.com"
        className="inline-flex items-center gap-2 text-sm font-body text-amber-700 hover:text-amber-800 transition-colors cursor-pointer"
        rel="nofollow"
      >
        <div className="w-4 h-4 flex items-center justify-center">
          <i className="ri-mail-line text-sm" />
        </div>
        Contactar con soporte
      </a>
    </div>
  </div>
);

export default OrderDetails;
